<template>
  <el-dialog
    :visible.sync="innerVisible"
    width="480px"
    custom-class="ca-invoice-view"
    :close-on-click-modal="true"
    title="发票信息"
  >
    <div v-loading="loading" class="ca-invoice-view__body">
      <div class="ca-invoice-view__order">
        <span class="ca-invoice-view__order-label">订单号：</span
        >{{ detail.orderCode || order.orderCode }}
      </div>
      <div class="ca-invoice-view__status">发票状态：{{ statusText }}</div>
      <div v-for="item in rows" :key="item.label" class="ca-invoice-view__row">
        <span class="ca-invoice-view__label">{{ item.label }}</span>
        <span class="ca-invoice-view__value">{{ item.value }}</span>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { getInvoice } from '@/api/ca'
import { INVOICE_STATUS_TEXT, INVOICE_TYPE_TEXT } from '../util/caForm'

// 行定义：label 与编辑页字段名完全一致（不带冒号），key 顺序即渲染顺序
const ROW_DEFS = [
  { key: 'invoiceTitle', label: '发票抬头' },
  { key: 'taxNumber', label: '纳税人识别号' },
  { key: 'invoiceType', label: '发票类型' },
  { key: 'invoiceAddress', label: '开票地址' },
  { key: 'invoicePhone', label: '开票电话' },
  { key: 'invoiceBank', label: '开票户行' },
  { key: 'invoiceBankNo', label: '开票户行账号' },
  { key: 'invoiceRemark', label: '开票备注' },
  { key: 'invoiceEmail', label: '接收发票邮箱' },
]

export default {
  name: 'InvoiceViewDialog',
  props: {
    visible: { type: Boolean, default: false },
    order: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      loading: false,
      detail: {}, // 订单详情（含发票字段）
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(v) {
        this.$emit('update:visible', v)
      },
    },
    statusText() {
      return INVOICE_STATUS_TEXT[String(this.detail.invoiceStatus)] || '--'
    },
    rows() {
      return ROW_DEFS.map((def) => ({
        label: def.label,
        value: this.displayValue(def.key),
      }))
    },
  },
  watch: {
    visible(v) {
      if (v) this.loadDetail()
    },
  },
  methods: {
    // 打开时查询发票信息（文档 §4.9，CaInvoiceVo 原样渲染，空值由 displayValue 兜底 --）
    loadDetail() {
      this.loading = true
      getInvoice({ orderId: this.order.orderId })
        .then((res) => {
          this.detail = res.data || {}
        })
        .catch(() => {
          // 加载失败关闭弹框（错误提示由请求拦截器统一处理）
          this.innerVisible = false
        })
        .finally(() => {
          this.loading = false
        })
    },
    displayValue(key) {
      const v = this.detail[key]
      if (key === 'invoiceType') return INVOICE_TYPE_TEXT[String(v)] || '--'
      return v || '--'
    },
  },
}
</script>
